import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';

class ChannelBuilderComponentController {
  private isMobile: boolean = true;
  private detail: any;
  constructor() {
    this.isMobile = PlatformUtility.isMobile();
  }

  openChannel() {
    //handle spaces in urls
    const link = encodeURI(this.detail.metadata.link[PlatformUtility.getPlatform()]);
    if (PlatformUtility.isMobile() && link.indexOf('http') !== -1) {
      window.open(link, '_blank');
    } else {
      if (PlatformUtility.isAndroid()) {
        window.open(link, '_system');
      } else {
        window.open(link);
      }
    }
  }
}

export class ChannelBuilderComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-sgd-components/src/components/channel_component/channel_builder_component.html';
  public controller = ChannelBuilderComponentController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    detail: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-sgd-components/src/components/channel_component/channel_builder_component_controller.ts